module.exports = __webpack_public_path__ + "static/media/simon.227ff3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/simon.jpg
// module id = 136
// module chunks = 0